import { Button, Typography, Space, Flex, message } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import {
  useCreateWorkflowMutation,
  useUpdateWorkflowMutation,
} from '../../../store/workflows/workflowApi';
import { clearAllFilters, selectActiveFilters } from '../../../store/products/slice';
import { clearWorkflowCreatePayload, setIsDrawerOpen } from '../../../store/workflows/slice';
import { removeUnderscoresAndCapitalize } from '@admin-panel/utils';
import { ensureRootNode } from './JobInfo/TagsFamily/utils';

const { Text } = Typography;

const ReviewAndLaunch = () => {
  const workflowPayload = useAppSelector(state => state.workflows.workflowCreatePayload);
  const activeFilters = useAppSelector(selectActiveFilters);

  const [createWorkflow, { isLoading: isCreating }] = useCreateWorkflowMutation();
  const [updateWorkflow, { isLoading: isUpdating }] = useUpdateWorkflowMutation();

  const dispatch = useAppDispatch();

  const handleLaunch = async () => {
    if (!workflowPayload) {
      message.error('Please complete all required fields');
      return;
    }

    const tagFamily = ensureRootNode(
      workflowPayload.tagFamily,
      workflowPayload.tagFamily?.[0]?.allowMultiple ?? false,
    );

    try {
      if ('id' in workflowPayload && workflowPayload.id) {
        await updateWorkflow({
          ...workflowPayload,
          id: workflowPayload.id,
          tagFamily,
          fields: workflowPayload.fields || ['IMAGES'],
          scopeQuerySet: [
            {
              filters: activeFilters,
            },
          ],
        }).unwrap();
        message.success('Tagging job updated successfully!');
      } else {
        await createWorkflow({
          ...workflowPayload,
          qcNeeded: workflowPayload.qcNeeded ?? true,
          type: 'STYLE_TAGGING',
          scheduleType: workflowPayload.scheduleType || 'ONGOING',
          tagFamily,
          fields: workflowPayload.fields || ['IMAGES'],
          scopeQuerySet: [
            {
              filters: activeFilters,
            },
          ],
        }).unwrap();

        message.success('Tagging job launched successfully!');
      }

      dispatch(clearWorkflowCreatePayload());
      dispatch(clearAllFilters());
      dispatch(setIsDrawerOpen(false));
    } catch (error) {
      console.error('Failed to launch tagging job:', error);
      message.error('Failed to launch tagging job');
    }
  };

  return (
    <Flex
      vertical
      align="flex-end"
      gap={16}
      style={{
        width: '100%',
      }}
    >
      <Space
        direction="vertical"
        style={{
          width: '100%',
          padding: 16,
          background: '#FFFFFF',
          borderRadius: 20,
          border: '1px solid #F4F4F4',
        }}
      >
        <Text>Job Name: {workflowPayload?.name || 'Not specified'}</Text>
        <Text>Job Type: {removeUnderscoresAndCapitalize(workflowPayload?.scheduleType ?? '')}</Text>
      </Space>

      <Button
        type="primary"
        size="middle"
        loading={isCreating || isUpdating}
        disabled={!workflowPayload?.name}
        style={{
          backgroundColor: '#171717',
          borderColor: '#171717',
          borderRadius: 20,
        }}
        onClick={handleLaunch}
      >
        {isCreating
          ? 'CREATING...'
          : isUpdating
            ? 'UPDATING...'
            : workflowPayload && 'id' in workflowPayload && workflowPayload.id
              ? 'UPDATE'
              : 'LAUNCH'}
      </Button>
    </Flex>
  );
};

export default ReviewAndLaunch;
